// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit_pp.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { PursuitPPContent, PursuitPPView } from "../../datagateway/v1/pursuit_pp_pb";
/**
 * @generated from message mono.projectdata.v1.SelectPursuitPPRequest
 */ export class SelectPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: mono.datagateway.v1.PursuitPPContent content = 4;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectPursuitPPRequest, "runtime", proto3);
_define_property(SelectPursuitPPRequest, "typeName", "mono.projectdata.v1.SelectPursuitPPRequest");
_define_property(SelectPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content",
            kind: "message",
            T: PursuitPPContent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RevisePursuitPPRequest
 */ export class RevisePursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new RevisePursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevisePursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevisePursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevisePursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 expected_revision = 3;
   */ _define_property(this, "expectedRevision", 0), /**
   * @generated from field: mono.datagateway.v1.PursuitPPContent content = 4;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevisePursuitPPRequest, "runtime", proto3);
_define_property(RevisePursuitPPRequest, "typeName", "mono.projectdata.v1.RevisePursuitPPRequest");
_define_property(RevisePursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "content",
            kind: "message",
            T: PursuitPPContent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitPPRequest
 */ export class GetPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 revision = 3;
   */ _define_property(this, "revision", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPPRequest, "runtime", proto3);
_define_property(GetPursuitPPRequest, "typeName", "mono.projectdata.v1.GetPursuitPPRequest");
_define_property(GetPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitPPRequest
 */ export class ListPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPPRequest, "runtime", proto3);
_define_property(ListPursuitPPRequest, "typeName", "mono.projectdata.v1.ListPursuitPPRequest");
_define_property(ListPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SelectPursuitPPResponse
 */ export class SelectPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectPursuitPPResponse, "runtime", proto3);
_define_property(SelectPursuitPPResponse, "typeName", "mono.projectdata.v1.SelectPursuitPPResponse");
_define_property(SelectPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RevisePursuitPPResponse
 */ export class RevisePursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new RevisePursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevisePursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevisePursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevisePursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevisePursuitPPResponse, "runtime", proto3);
_define_property(RevisePursuitPPResponse, "typeName", "mono.projectdata.v1.RevisePursuitPPResponse");
_define_property(RevisePursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitPPResponse
 */ export class GetPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPPResponse, "runtime", proto3);
_define_property(GetPursuitPPResponse, "typeName", "mono.projectdata.v1.GetPursuitPPResponse");
_define_property(GetPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitPPResponse
 */ export class ListPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitPPView selections = 1;
   */ _define_property(this, "selections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPPResponse, "runtime", proto3);
_define_property(ListPursuitPPResponse, "typeName", "mono.projectdata.v1.ListPursuitPPResponse");
_define_property(ListPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selections",
            kind: "message",
            T: PursuitPPView,
            repeated: true
        }
    ]));
